import { IoLink } from "react-icons/io5";
import SortupDialog from "./common/SortupDialog";
import { useToast } from "../@/components/ui/use-toast";

interface ShareButtonProps {
  text: string;
  title: string;
  url: string;
  isDialogOpen: boolean;
  setIsDialogOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

const ShareButton: React.FC<ShareButtonProps> = ({
  text,
  title,
  url,
  isDialogOpen,
  setIsDialogOpen,
}) => {
  const { toast } = useToast();
  const handleCopyLink = () => {
    navigator.clipboard
      .writeText(url)
      .then(() => {
        toast({
          title: "Link copied to clipboard!",
          description: "You can now share this link with others.",
        });
        setIsDialogOpen(false);
      })
      .catch((error) => {
        console.error("Failed to copy link", error);
        toast({
          title: "Failed to copy link",
          description: "Please try again.",
        });
      });
  };

  return (
    <>
      <SortupDialog
        isOpen={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        bodyClassName="max-w-[200px]"
        header={title}
        footerButtons={[
          {
            name: "Copy Link",
            onClick: handleCopyLink,
            className: "px-6 py-3 bg-customGreenColor text-white rounded-lg",
            disabled: false,
            icon: <IoLink className="text-xl" />,
          },
          {
            name: "Close",
            onClick: () => setIsDialogOpen(false),
            className: "px-6 py-3 bg-white text-gray-900 border rounded-lg",
            disabled: false,
          },
        ]}
      >
        <p className="text-wrap">{text}</p>
      </SortupDialog>
    </>
  );
};

export default ShareButton;
